<template>
  <div class="parentx">
    <div>
      <template v-for="(menuItem, index) in menuItems" v-if="!user.change_password">
        <side-bar-route-item
          :menuItem="menuItem"
          v-bind:key="`route.${index}`" ></side-bar-route-item>
      </template>
    </div>
  </div>
</template>

<script>
import SideBarRouteItem from "@views/template/SideBar/SideBarRouteItem";
import VNavMenuGroup from "../../../layouts/components/vertical-nav-menu/VerticalNavMenuGroup";
export default {
  name: "SideBarRouteList",
  components: {VNavMenuGroup, SideBarRouteItem},
  props: {
    expandSingle: {
      type: Boolean,
      required: true
    },
    menuItems: {
      required: true
    }
  }
}
</script>

<style scoped>
</style>
